import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { CREATE_PARKING_WHITELIST_GROUP } from './types';

export const createParkingWhitelistGroup = createTaskAction(
  CREATE_PARKING_WHITELIST_GROUP,
);
